import { Grid } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { StyledCheckSerialNumber } from "./checkSerialNumber.style";
import DeviceDetailsForm from "./deviceDetailsForm";
import HlxButton from "component/commonComponents/button/button";
import TextBox from "component/commonComponents/Textbox";
import WarningIcon from '@mui/icons-material/Warning';


export interface ICheckSerialNumberDeviceProps {
    handleCheckSerialNumber?: Function,
    loadingCheckSN?: boolean,
    isOpen?: boolean,
    errors: Array<any>,
    label: string,
    dataDeviceDetails: any,
    valueDetailForm: Function,
    onSearch: any,
    manualInput?: boolean,
    kbNumber: string,
    cleanData?: boolean,
    locale?: any, // object
    textShow?: any,
    isSpecialCharacterAllowed?: boolean;
}
const enterKey = 13;

const CheckSerialNumberDevice: React.FC<ICheckSerialNumberDeviceProps> = (props): JSX.Element => {
  const {
      handleCheckSerialNumber = () => {},
      isOpen,
      label,
      dataDeviceDetails,
      valueDetailForm = () =>{},
      manualInput,
      kbNumber,
      locale,
      textShow,
      isSpecialCharacterAllowed
    } = props;
  let hasData = !!dataDeviceDetails;

  const [valueSN, setValueSN] = useState(hasData ? dataDeviceDetails?.serial_number : '');
  const [cleanData, setCleanData] = useState(false);
  const [valueInput, setValueInput] = useState('');
  const [isChangeDeviceDetails, setIsChangeDeviceDetails] = useState(false);

  const searchRef: any = useRef(null);

  const keyPress = (e: any) => {
    if (e.keyCode === enterKey) {
      handleSearch();
    }
  };

  const handleChange = (e: any) => {
    setValueSN(e.target.value);
    if (valueSN !== undefined && valueSN !== e.target.value) {
      setCleanData(true);
    } else if (valueSN === undefined && dataDeviceDetails) {
      setCleanData(true);
    } else {
      setCleanData(false);
    }
  };

  const handleSearch = () => {
    if (!!valueSN) {
      handleCheckSerialNumber(valueSN);
    } else {
      searchRef.current.focus();
    }
  };

  const callBackDataDeviceDetailForm = (value: any) =>{
    if(value?.serial_number === undefined ) {
      setIsChangeDeviceDetails(false);
    } else if (value?.manufacturer !== '' || value?.model !== '' && value?.serial_number === '') {
      setIsChangeDeviceDetails(true);
    } else {
      setIsChangeDeviceDetails(true);
    }
    return valueDetailForm(value);
  };

  useEffect(() =>{
    if(isChangeDeviceDetails && searchRef.current.value === valueSN) {
      setCleanData(false);
    };

    if(valueSN === undefined && dataDeviceDetails?.serial_number) {
      setValueInput(dataDeviceDetails?.serial_number);
    } else {
      setValueInput(valueSN);
    }

  },[valueSN, dataDeviceDetails, props.cleanData]);

  return (
    <>
      <StyledCheckSerialNumber>
        <Grid className="section-sn section-sn-check-user">
          <Grid xs={12} item>
            <label className="label-form">{label}</label>
          </Grid>
          <Grid xs={12} item className="sn-control">
            <Grid xs={12} item className="sn-item">
              <TextBox
                id='sn'
                className='sn-input'
                type="text"
                onKeyDown={keyPress}
                placeholder={''}
                name='serialnumber'
                value={valueInput}
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                onChange={(e) => handleChange(e)}
                fullWidth
                inputRef={searchRef}
                textboxToolTip={locale?.textboxToolTip}
              />
            </Grid>
            <Grid xs={12} item className="sn-item">
                <HlxButton label={locale?.searchBtn}  onClick={handleSearch} />
            </Grid>
          </Grid>
        </Grid>
        {isOpen &&
          <Grid className="section-sn-error">
            <Grid xs={12} item className="sn-control">
              <WarningIcon/>
              <p>
                {locale?.errorText}
              </p>
            </Grid>
          </Grid>
        }
      </StyledCheckSerialNumber>

      <DeviceDetailsForm
        open={isOpen}
        dataSearchSN={dataDeviceDetails}
        detailsForm={callBackDataDeviceDetailForm}
        isManualInput={manualInput}
        disabledRequired={true}
        kbNumber={kbNumber}
        valueInput={valueSN}
        cleanData={cleanData}
        locale={locale?.deviceDetailsForm}
        textShow={textShow}
        isSpecialCharacterAllowed={isSpecialCharacterAllowed}
      />
    </>
  );
};

CheckSerialNumberDevice.defaultProps = {
  handleCheckSerialNumber: () => {},
  label:'Serial Number',
  loadingCheckSN: false,
  errors: [],
  locale: {
    searchBtn: 'Search',
  },
};

export default CheckSerialNumberDevice;
